import type { SVGProps } from 'react'

export const LogoIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="32" height="26" viewBox="0 0 32 26" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.91 0.5L21.791 6.28334L32 4.45589L27.5011 25.5L15.9079 23.6904L15.8828 23.6946L5.08842 25.4862L0.0633834 4.63686L0 4.37276L10.0582 6.20448L15.91 0.5ZM9.27604 18.8478L15.8823 17.7515L23.27 18.9046L24.7586 11.7082L19.984 12.5636L15.9024 8.54982L15.8933 8.54138L11.8439 12.4878L7.55513 11.7072L9.27604 18.8478Z"
      fill="currentColor"
    />
  </svg>
)
